import { keyBy } from 'lodash';

import { type api } from 'common';

import {
  type ReactFlowInputParameterConfig,
  convertInputSchemaToParametersConfig,
} from '../../../Start/parameterConfig';

type FlowArgument = api.FlowDefinition.FlowArgument;

type ArgumentRow =
  | {
      parameter?: ReactFlowInputParameterConfig;
      argument: FlowArgument;
      fieldIndex: number;
    }
  | {
      parameter: ReactFlowInputParameterConfig;
      argument?: undefined;
      fieldIndex?: undefined;
    };

export function buildFlowArgumentRows({
  inputSchema,
  flowArguments,
}: {
  inputSchema?: api.FlowDefinition.FlowInputSchema;
  flowArguments: FlowArgument[];
}): ArgumentRow[] {
  // First, for each parameter, list either the corresponding argument or an
  // empty placeholder, then append any remaining arguments
  const parameters = convertInputSchemaToParametersConfig(inputSchema) ?? [];
  const argumentsByName = keyBy(flowArguments, ({ name }) => name);
  const fieldIndexesByArgumentName = Object.fromEntries(
    flowArguments.map((argument, index) => [argument.name, index])
  );
  const parameterRows = parameters.map<ArgumentRow>((parameter) => {
    const argument = argumentsByName[parameter.name];
    const fieldIndex = fieldIndexesByArgumentName[parameter.name];
    return { parameter, argument, fieldIndex };
  });
  const additionalRows = flowArguments
    .map((argument, fieldIndex) => ({ argument, fieldIndex }))
    .filter(({ argument }) => !inputSchema?.properties[argument.name]);
  return [...parameterRows, ...additionalRows];
}
